<template>
  <div class="grid-container">
    <form :class="{'opacity-50': isWorking}" @submit.prevent="submit">
      <section-header size="xl" variants="dividing" class="mt-3">
        <heading level="1" size="xl" v-html="bp('updatePwd.title')"></heading>
      </section-header>
      <p class="mb-3 text-base" v-html="bp('updatePwd.description')"></p>
      <pdl-callout v-if="message" :kind="messageType">
        <template #content>
          <span v-html="message" />
        </template>
      </pdl-callout>
      <div class="max-w-sm mb-6">
        <form-group
          ref="password"
          v-model="password"
          v-validate="'required|checkPassword'"
          type="password"
          name="password"
          :label="bp('updatePwd.pwd')"
          :data-vv-as="bp('updatePwd.pwd')"
          :error="errors.first('password')"
          :help-text="bp('register.infoPassword')"
          :show-error-messages="true"
          required
        />
        <form-group
          v-model="passwordConfirmation"
          v-validate="'required|confirmed:password|checkPassword'"
          type="password"
          name="resetPasswordConfirmation"
          :label="bp('updatePwd.checkPwd')"
          :data-vv-as="bp('updatePwd.checkPwd')"
          :error="errors.first('resetPasswordConfirmation')"
          :show-error-messages="true"
          required
        />

        <div class="buttons">
          <trek-button primary type="submit" :disabled="isWorking" @click="submit">{{
            bp('updatePwd.submit')
          }}</trek-button>
          <trek-button secondary @click="cancel">{{ bp('text.account.profile.cancel') }}</trek-button>
        </div>
      </div>
    </form>
  </div>
</template>
<script>
import get from 'lodash/get';
import Heading from '@/components/Heading';
import {PdlCallout} from '@pedal/pdl-callout';
import FormGroup from '@/components/FormGroup';
import TrekButton from '@/components/TrekButton';
import SectionHeader from '@/components/SectionHeader';
import {initPasswordRules} from '@/components/containers/my-account/utils/password-rules';
import {UserAccountBase} from '@/components/containers/my-account/utils/user-account-base';

export default {
  name: 'ForgotPasswordResetContainer',
  components: {Heading, PdlCallout, FormGroup, SectionHeader, TrekButton},
  extends: UserAccountBase,
  data() {
    return {
      password: '',
      passwordConfirmation: '',
      isWorking: false,
    };
  },
  created() {
    initPasswordRules(this.bp('register.infoPassword'));
    this.useCustomPasswordValidationMessages({
      passwordField: 'password',
      passwordConfirmationField: 'resetPasswordConfirmation',
    });
  },
  methods: {
    /**
     * Handle email update.
     * @return {Promise<void>}
     */
    async processUpdate() {
      this.isWorking = true;
      try {
        let data = {
          pwd: this.password,
          checkPwd: this.passwordConfirmation,
          token: this.options.token,
        };

        if (this.options.CSRFParamName) {
          data[this.options.CSRFParamName] = this.options.CSRFToken;
        }

        const response = await this.api.recoveryUpdatePassword(window.location.href, data);
        const isError = get(response.data.meta, 'feedback.type') !== 'success';
        const message = get(response.data.meta, 'feedback.message.basePropertyValue');

        this[isError ? 'displayError' : 'displaySuccess'](message);
      } catch (e) {
        this.displayError(e.message);
      } finally {
        this.isWorking = false;
      }
    },
  },
};
</script>
